import { render } from "./who-tags.vue?vue&type=template&id=0fc4452f&lang=pug"
import script from "./who-tags.vue?vue&type=script&lang=js"
export * from "./who-tags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__